import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { DEFAULT_LOCALE } from "../views/lessons/constants";
import { LessonListResponseDto } from "./lessonDtos";

export type ListLessonsParams = {
  locale?: string;
  page?: number; // 1-indexed
  limit?: number;
  search?: string;
  joints?: string[];
  state?: string;
};

const buildQuery = (params: ListLessonsParams): string => {
  const qs = new URLSearchParams();
  qs.set("locale", params.locale ?? DEFAULT_LOCALE);
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));
  if (params.search && params.search.trim()) qs.set("search", params.search.trim());
  if (params.state) qs.set("state", params.state);
  (params.joints ?? []).forEach(j => qs.append("joint", j));
  return qs.toString();
};

export const useListLessons = (params: ListLessonsParams = {}) =>
  useQuery<LessonListResponseDto>(
    queryKeys.lessonsList(params),
    async () => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const data = await api.parse(`GET /lessons?${buildQuery(params)}`, { root: supportApiBase });
      return Array.isArray(data) ? { items: data } : data ?? { items: [] };
    },
    { keepPreviousData: true }
  );
